import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import './index.css';
import AccountBar from './components/AccountBar.tsx';
import Landing from './routes/Landing.tsx';
import Created from './routes/Created.tsx';
import Slideshow from './routes/Slideshow.tsx';
import Admin from './routes/Admin.tsx';
import Upload from './routes/Upload.tsx';
import Ops from './routes/Ops.tsx';
import SignUp from './routes/SignUp.tsx';
import SignIn from './routes/SignIn.tsx';
import Verify from './routes/Verify.tsx';
import Forgot from './routes/Forgot.tsx';
import Reset from './routes/Reset.tsx';
import Dashboard from './routes/Dashboard.tsx';
import NotFound from './routes/NotFound.tsx';

/**
 * Every page that a person looks at holds the account bar, and the column it
 * sits in owns the viewport height - pages fill what is left with `flex-1`
 * rather than each claiming `min-h-dvh` and pushing the bar off the top.
 */
function Chrome() {
  return (
    <div className="flex min-h-dvh flex-col">
      <AccountBar />
      <Outlet />
    </div>
  );
}

const router = createBrowserRouter([
  // The slideshow is the one route with no chrome at all: it is a screen on a
  // wall, not a page someone is signed in to.
  { path: '/s/:sessionId', element: <Slideshow /> },
  {
    element: <Chrome />,
    children: [
      { path: '/', element: <Landing /> },
      { path: '/created', element: <Created /> },
      { path: '/signup', element: <SignUp /> },
      { path: '/signin', element: <SignIn /> },
      { path: '/verify', element: <Verify /> },
      { path: '/forgot', element: <Forgot /> },
      { path: '/reset', element: <Reset /> },
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/a/:adminToken', element: <Admin /> },
      { path: '/u/:sessionId', element: <Upload /> },
      { path: '/ops', element: <Ops /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
